"use strict";

(function() {

	/***************************************
		Main Events
	***************************************/

	var init = function() {
	}





	init();
})();